'use client'

import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  cssVariables: true,
  palette: {
    primary: {
      main: '#00549E',
    },
    info: {
      main: '#EEE67E',
    },
    text: {
      primary: '#00549E',
      secondary: '#6B6B6B',
    },
  },
  typography: {
    fontFamily: `var(--lato-font-family)`,
    h1: {
      fontSize: 32,
      lineHeight: 1.25,
      fontWeight: 700,
    },
    subtitle1: {
      fontSize: 20,
      lineHeight: 1.4,
      fontWeight: 400,
    },
    body1: {
      fontSize: 20,
      lineHeight: 1.4,
      fontWeight: 400,
    },
    body2: {
      fontSize: 20,
      lineHeight: 1.4,
      fontWeight: 700,
    },
    caption: {
      fontSize: 16,
      lineHeight: 1.5,
      fontWeight: 400,
    },
  },
  components: {
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          h1: 'h1',
          h2: 'h2',
          h3: 'h3',
          h4: 'h4',
          h5: 'h5',
          h6: 'h6',
          subtitle1: 'p',
          subtitle2: 'p',
          body1: 'p',
          body2: 'blockquote',
          inherit: 'p',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: '50px',
          padding: '.6rem 3.6rem',
        },
      },
    },
  },
})

export default theme
